$(document).ready(() => {
    const globalOptIn = $('#newsletter-and-promotions');
    const brandLevelOptInContainer = $('.newsletter-container');
    const brandLevelOptIns = $('.newsletter-brand-checkbox');

    console.log(globalOptIn);

    globalOptIn.on('change', function () {
        if (globalOptIn.prop('checked')) {
            brandLevelOptInContainer.removeClass('d-none');
        } else {
            brandLevelOptInContainer.addClass('d-none');
            brandLevelOptIns.prop('checked', false);
        }
    });
})
